function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { getFullScope, inferType } from "./helpers";
export var guessStrategy = function guessStrategy(i18n, scope) {
  if (scope instanceof Array) {
    scope = scope.join(i18n.defaultSeparator);
  }

  var message = scope.split(i18n.defaultSeparator).slice(-1)[0];
  return i18n.missingTranslationPrefix + message.replace("_", " ").replace(/([a-z])([A-Z])/g, function (_match, p1, p2) {
    return "".concat(p1, " ").concat(p2.toLowerCase());
  });
};
export var messageStrategy = function messageStrategy(i18n, scope, options) {
  var fullScope = getFullScope(i18n, scope, options);
  var locale = "locale" in options ? options.locale : i18n.locale;
  var localeType = inferType(locale);
  var fullScopeWithLocale = [localeType == "string" ? locale : localeType, fullScope].join(i18n.defaultSeparator);
  return "[missing \"".concat(fullScopeWithLocale, "\" translation]");
};
export var errorStrategy = function errorStrategy(i18n, scope, options) {
  var fullScope = getFullScope(i18n, scope, options);
  var fullScopeWithLocale = [i18n.locale, fullScope].join(i18n.defaultSeparator);
  throw new Error("Missing translation: ".concat(fullScopeWithLocale));
};
export var MissingTranslation = /*#__PURE__*/function () {
  function MissingTranslation(i18n) {
    _classCallCheck(this, MissingTranslation);

    this.i18n = i18n;
    this.registry = {};
    this.register("guess", guessStrategy);
    this.register("message", messageStrategy);
    this.register("error", errorStrategy);
  }

  _createClass(MissingTranslation, [{
    key: "register",
    value: function register(name, strategy) {
      this.registry[name] = strategy;
    }
  }, {
    key: "get",
    value: function get(scope, options) {
      var _a;

      return this.registry[(_a = options.missingBehavior) !== null && _a !== void 0 ? _a : this.i18n.missingBehavior](this.i18n, scope, options);
    }
  }]);

  return MissingTranslation;
}();